import { AppState } from '../../../reducers/index';
import { createSelector } from '@ngrx/store';
import * as fromServiceFormulaSchemeReducer from './service-formula-scheme.reducer';

export const currentState = (state: AppState) => (state[fromServiceFormulaSchemeReducer.serviceFormulaSchemesFeatureKey]);

export const selectAllServiceFormulaSchemes = createSelector(currentState, fromServiceFormulaSchemeReducer.selectAll);

export const selectTotalServiceFormulaSchemes = createSelector(currentState, fromServiceFormulaSchemeReducer.selectTotal);

export const selectModifiedServiceFormulaSchemes = createSelector(selectAllServiceFormulaSchemes, (serviceFormulaSchemes) => {
  return serviceFormulaSchemes.map((serviceFormulaScheme) => {
    return {
      ...serviceFormulaScheme
    };
  });
});
